export class Counters {
  counters;
  animationSpeed = 1000;

  constructor() {}

  init() {
    this.counters = document.querySelectorAll('.home-counters-count-value');

    if (!this.counters) return;

    this.counters.forEach((el) => {
      let animated = false;

      window.addEventListener('scroll', () => {
        const elementTop = el.getBoundingClientRect().top;

        if (
          !animated &&
          elementTop <=
            (window.innerHeight || document.documentElement.clientHeight) / 1.25
        ) {
          animated = true;
          this.animateCounter(el);
        }
      });
    });
  }

  animateCounter(el) {
    const value = +el.dataset.count;
    const data = +el.innerText;

    const time = value / this.animationSpeed;

    if (data < value) {
      el.innerText = Math.ceil(data + time);
      setTimeout(() => {
        this.animateCounter(el);
      }, 1);
    } else {
      el.innerText = value;
    }
  }
}
